// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"CompanyResourcesContainer_pageWrapper__1RGxk","resources":"CompanyResourcesContainer_resources__2XsWt"};